const translationsDe = {
  de: {
    login: {
      form: {
        welcome: 'Willkommen zurück',
        to: 'Analyse von Track-Daten',
        vendor: 'Aviation Technologies. We create future',
        userName: 'Benutzername',
        authorize: 'Anmelden',
        password: 'Passwort',
        userUnexist: 'Benutzer existiert nicht'
      }
    },
    tracksTree: {
      apply: 'Übernehmen',
      toolbar: {
        trackList: 'Track-Liste'
      },
      menuDropdown: {
        fileMenu: 'Menü',
        expand: 'Aufklappen',
        collapse: 'Zuklappen',
        delete: 'Löschen',
        export: 'Exportieren',
        process: 'Verarbeiten',
        removeSelection: 'Auswahl aufheben',
        exportCoordinates: 'Koordinaten exportieren',
        events: 'Ereignisse',
        params: 'Parameter',
        templates: 'Vorlagen'
      },
      trackTitle: {
        organization: 'Org.',
        vehicle: 'Fahrzeug',
        name: 'Track',
        organization: 'Organisation',
        startedAt: 'Track-Startzeit',
        origin: 'Start',
        destination: 'Ziel',
        previous: 'Zurück',
        next: 'Weiter',
        loading: 'Laden...',
        noRowsFound: 'Keine Einträge gefunden',
        page: 'Seite',
        of: 'von',
        rows: 'Zeilen',
      },
      trackControls: {
        confirm: 'Löschen des Tracks bestätigen',
      },
      folderControls: {
        confirm: 'Löschen des Ordners bestätigen',
      },
    },
    tracksTable: {
      toolbar: {
        trackList: 'Track-Liste'
      },
      menuDropdown: {
        fileMenu: 'Menü',
        delete: 'Löschen',
        export: 'Exportieren',
        process: 'Verarbeiten',
        removeSelection: 'Auswahl aufheben',
        exportCoordinates: 'Koordinaten exportieren',
        events: 'Ereignisse',
        params: 'Parameter',
        templates: 'Vorlagen'
      },
      table: {
        vehicle: 'Fahrzeug',
        name: 'Track',
        organization: 'Organisation',
        startedAt: 'Track-Startzeit',
        origin: 'Start',
        destination: 'Ziel',
      }
    },
    uploadingPreview: {
      toolbar: {
        preview: 'Vorschau'
      }
    },
    settings: {
      list: {
        options: 'Benutzereinstellungen',
        save: 'Speichern',
        printTableStep: 'Schrittweite der Drucktabelle',
        mainChartColor: 'Hintergrundfarbe des Hauptdiagramms',
        lineWidth: 'Linienbreite im Diagramm',
        trackShowAction: 'Aktion beim Öffnen eines Tracks',
        pointsMaxCount: 'Max. Anzahl Punkte im Diagramm'
      }
    },
    trackStatistics: {
      toolbar: {
        aggregatedStatistics: 'Aggregierte Statistik',
      },
      trackFilter: {
        trackInfoFilter: 'Nach Track-Info filtern',
        apply: 'Übernehmen',
        recorderType: 'Rekorder-Typ',
        vehicle:'Fahrzeug',
        name:'Track',
        departureFromDate:'Von Datum',
        departureToDate:'Bis Datum',
        origin: 'Start',
        destination: 'Ziel',
      },
      paramsFilter: {
        apply: 'Übernehmen',
        putTrackFilter: 'Track-Filter setzen',
        noMonitoredParamsOnSpecifyedFilter: 'Keine überwachten Parameter für den gewählten Filter',
        monitoredParameters: 'Überwachte Parameter',
      },
      values: {
        results: 'Bericht',
        setParamsForReportGenerating: 'Parameter für die Berichtserstellung festlegen',
        noDataToGenerateReport: 'Keine Daten für den Bericht',
      },
      valuesRow: {
        title: 'Parameter',
        count: 'Anzahl',
        min: 'Min',
        avg: 'Mittel',
        sum: 'Summe',
        max: 'Max',
      },
    },
    trackTemplates: {
      item: {
        events: 'Ereignisse',
        default: 'Standard',
        last: 'Zuletzt angesehen'
      }
    },
    trackEvents: {
      formPrint: {
        grayscale: 'Graustufen'
      },
      trackComment: {
        operatorAdmitted: 'Operator zugelassen',
        vehicleAllowed: 'Fahrzeug zugelassen',
        generalAdmission: 'Allgemeine Freigabe',
        save: 'Speichern'
      },
      title: {
        recorderName: 'Rekorder',
        vehicle: 'Fahrzeug',
        name: 'Track',
        startedAt: 'Zeit und Datum des Tracks',
        origin: 'Start',
        destination: 'Ziel',
        centringto: 'Schwerpunkt Start',
        centringlndg: 'Schwerpunkt Landung',
        weightto: 'Gewicht Start',
        weightlndg: 'Gewicht Landung',
        tto: 'Temperatur Start',
        operator: 'Operator',
        route: 'Route',
        centring: 'Schwerpunkt',
      },
      list: {
        processingNotPerformed: 'Verarbeitung nicht durchgeführt',
        noEvents: 'Keine Ereignisse gefunden'
      },
      collapse: {
        eventCodeMask000: "Technologische Meldungen",
        eventCodeMask001: "Steuerung der Flugausrüstung",
        eventCodeMask002: "Zustandsüberwachung",
        eventCodeMask003: "Informationsmeldungen",
      },
      contentHeader: {
        start: 'Start',
        end: 'Ende',
        duration: 'Dauer',
        code: 'Code',
        eventName: 'Name',
        algorithm: 'Algorithmus',
        aditionalInfo: 'Zusatzinfo',
        reliability: 'Zuverlässigkeit',
        comment: 'Kommentar',
      }
    },
    calibration: {
      toolbar: {
        title: 'Kalibrierung'
      },
      table: {
        recorder: 'Rekorder',
        name: 'Name',
        dateCreation: 'Erstellungsdatum',
        dateLastEdit: 'Letzte Bearbeitung'
      },
      create: 'Erstellen',
      creationForm: 'Formular zur Kalibrierungserstellung',
      for: 'für',
      paramName: 'Name',
      paramCode: 'Code',
      paramChannels: 'Kanäle',
      valueAdd: 'Hinzufügen',
      save: 'Speichern',
      update: 'Aktualisieren',
      list: 'Zur Liste',
      unexist: 'Keine Kalibrierungen',
      controls: 'Steuerung',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      inputName: 'Bitte Namen zum Speichern eingeben'
    },
    calibrationForm: {
      toolbar: {
        title: 'Kalibrierung für Rekorder %{recorderName}'
      },
      spreadsheetTitle: {
        code: 'Code',
        physics: 'Physik'
      },
      spreadsheet: {
        addButton: 'Zeile hinzufügen'
      },
      param: {
        code: 'Code',
        name: 'Name (Einheit)',
        channels: 'Kanäle',
        minValue: 'Min. Wert',
        maxValue: 'Max. Wert',
        deviationFromStandardView: 'Abweichung von der Standardansicht'
      }
    },
    trackUploader: {
      upload: 'Hochladen',
      filesList: 'Dateiliste',
    },
    usersTable: {
      toolbar: {
        list: 'Benutzerliste',
      },
      table: {
        login: 'Login',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        lang: 'Sprache',
        role: 'Rolle',
        company: 'Organisation',
        logo: 'Logo',
        create: 'Erstellen',
        edit: 'Bearbeiten',
        delete: 'Löschen',
        list: 'Liste',
        save: 'Speichern',
        confimUserDeleting: 'Löschen des Benutzers bestätigen'
      }
    },
    userForm: {
      toolbar: {
        create: 'Neuen Benutzer erstellen',
        edit: 'Benutzer bearbeiten'
      },
      form: {
        login: 'Login',
        name: 'Name',
        email: 'E-Mail',
        phone: 'Telefon',
        pass: 'Passwort',
        repeatPass: 'Passwort wiederholen',
        company: 'Organisation',
        role: 'Rolle',
        logo: 'Logo',
        avaliableRecorders: 'Verfügbare Rekorder festlegen',
        chooseFile: 'Logo wählen',
        notAllNecessarySent: 'Nicht alle erforderlichen Parameter ausgefüllt (mit * markiert)',
        alreadyExist: 'Benutzer mit diesem Login existiert bereits',
        creationError: 'Fehler bei der Benutzererstellung'
      },
      roleRadio: {
        admin: 'Admin',
        moderator: 'Moderator',
        user: 'Benutzer'
      }
    },
    userActivity: {
      toolbar: {
        list: 'Benutzeraktivität',
      },
      table: {
        action: 'Aktion',
        status: 'Status',
        message: 'Antwortnachricht',
        date: 'Datum'
      }
    },
    supervision: {
      verticalToolbar: {
        connectionParams: 'Verbindungsparameter',
        recorderType: 'Rekorder-Typ',
        start: 'Starten',
        stop: 'Stoppen',
        save: 'Speichern',
      },
      dataSource: {
        kvViaUdp: 'KV über UDP',
        file: 'Datei',
        fileViaUdp: 'Datei über UDP',
        connectionType: 'Verbindungstyp',
        sourceIps: 'Quell-IP-Adressen',
        addSource: 'Quelle hinzufügen',
        fakeData: 'Testdaten',
        chooseFile: 'Datei wählen',
        enterIpToConnect: 'Bitte IP zum Verbinden eingeben'
      },
      chooseParamsButtons: {
        chooseSource: 'Parameterquelle wählen',
        template: 'Vorlage',
        manual: 'Manuell',
        chooseParamsToShow: 'Anzuzeigende Parameter wählen',
        containerParams: 'Liste anzeigen',
        chooseParamsToShowInContainer: 'Anzuzeigende Parameter wählen',
        apply: 'Übernehmen'
      },
      physics: {
        header: 'Physikalische Parameterwerte',
        chooseParams: 'Bitte Parameter zum Anzeigen wählen'
      },
      binary: {
        header: 'Aktive Binärparameter'
      },
      events: {
        header: 'Analyse der Stream-Daten'
      },
      ungrouped: 'Ungruppiert'
    },
    chart: {
      threeDim: {
        model: {
          follow: 'Folgen',
          freeCamera: 'Freie Kamera',
        }
      }
    },
    topMenu: {
      brand: 'Vehiclesos',
      supervision: 'Überwachung',
      fileImport: 'Import',
      upload: 'Hochladen',
      trackImporterDropdown: {
        fileImport: 'Import',
        chooseFile: 'Datei wählen',
      },
      trackUploaderDropdown: {
        trackUploading: 'Track hochladen',
        chooseFile: 'Datei wählen',
        preview: 'Vorschau',
        on: 'Ein',
        off: 'Aus',
      }
    },
    recorderSelector: {
      placeholder: 'Rekorder-Typ wählen'
    },
    recorderTemplateSelector: {
      placeholder: 'Vorlage wählen',
      item: {
        default: 'Standard',
        last: 'Zuletzt',
        events: 'Ereignisse',
      }
    },
    cycloParams: {
      colorPicker: {
        cancel: 'Abbrechen',
        save: 'Speichern'
      }
    },
    mainMenu: {
      tracks: 'Tracks',
      recorders: 'Rekorder',
      calibration: 'Kalibrierung',
      users: 'Benutzer',
      results: 'Ergebnisse',
      search: 'Suche',
    },
    trackViewOptionsSwitch: {
      events: 'Ereignisse',
      params: 'Parameter',
      templates: 'Vorlagen'
    },
    trackListViewSwitch : {
      treeView: 'Baum',
      tableView: 'Tabelle',
    },
    trackTemplateEdit: {
      toolbar: {
        templates: 'Vorlagen'
      },
      saveForm: {
        templateName: 'Vorlagenname'
      }
    },
    table: {
      previous: 'Zurück',
      next: 'Weiter',
      loading: 'Laden...',
      noRowsFound: 'Keine Einträge gefunden',
      page: 'Seite',
      of: 'von',
      rows: 'Zeilen',
    }
  }
};

export default translationsDe;
